import {
    HxActiveSetEvent,
    HxActiveSetEventType,
    HxCollection,
    HxCollectionChangeType,
    HxObject,
    SessionId,
} from '@outlook/hxcore_web';
import { runInHxSession } from './runInHxSession';
import { getHxInstance } from './getHxInstance';
import { waitForHxChange } from './waitForHxChange';

/**
 * Wait for an item to be created in the given hx collection and return that item.
 */
export function waitForHxItemCreation<T extends HxObject>(
    hxCollection: HxCollection<T>,
    timeout: number
): Promise<T> {
    return runInHxSession(async (sessionId: SessionId) => {
        const collectionId = hxCollection.objectId;
        // Hold on to the collection to make sure we are getting change notifications for it.
        await getHxInstance().activeSet.getCollection(collectionId, sessionId);

        const evaluator = (event: HxActiveSetEvent): T | undefined => {
            if (
                event.type === HxActiveSetEventType.CollectionChanged &&
                event.update.collectionId.isEqual(collectionId)
            ) {
                const changes = event.update.changes;
                for (let i = 0; i < changes.length; i++) {
                    const change = changes[i];
                    if (change.type === HxCollectionChangeType.ItemCreated) {
                        return change.object as T;
                    }
                }
            }
            return undefined;
        };
        return waitForHxChange(evaluator, timeout);
    });
}
